import React from 'react';
import { Link } from 'fw/components/formatter/Formatter';

class SearchQueueLinkByStatus extends React.Component {
	handleClick = (e) => {
		e.stopPropagation();
		return false;
	}

	shouldComponentUpdate(nextProps) {
		return (
			nextProps.value !== this.props.value);
	}

	_getLinkValue() {
		const statusCode = this.props.dependentValues[0].statusCode;
		const rangeCode = this.props.dependentValues[1];

		var url = `/admin/searchQueue?showAll=true&certificationStatusCode=${statusCode}`;

		// Add days open filter - backend handles the date logic based on status
		if (rangeCode !== null) {
			url += `&certificationDaysOpen=${rangeCode}`;
		}

		return {
			url: url,
			title: this.props.value ? this.props.value : 0
		};
	}

	render() {
		const centerAlignStyle = { display: "block", textAlign: "center" };
		const value = this.props.value ? this.props.value : 0;

		// Zero value - show plain number without link
		if (value === 0) {
			return (
				<span style={centerAlignStyle}>
					{value}
				</span>
			);
		}

		return <Link value={this._getLinkValue()} style={centerAlignStyle}></Link>
	}
}

export default SearchQueueLinkByStatus;


// WEBPACK FOOTER //
// ./src/areas/shared/components/formatter/SearchQueueLinkByStatus.js